import { CareCoordinatorReferral, User } from 'types';
import { UnifiedReferralModel } from '../models/UnifiedReferralModel';

export interface AdapterContext {
    profileStage?: string;
    user: User;
}

export class CareCoordinatorReferralAdapter {
    private static determineStatusText(referral: CareCoordinatorReferral, profileStage?: string): string {
        const isCompleted = referral.ctp_caseload_referrals.length > 0;
        const isExpired = !referral.is_active;
        
        if (isCompleted) return 'Completed';
        if (isExpired) return 'Expired';
        if (profileStage === 'EXITED') return 'Member Unenrolled';
        return 'Pending';
    }

    private static formatParticipantName(participant: { id: number; name: string }, userId: number): string {
        return participant.id === userId ? 'You' : participant.name;
    }

    static adapt(referral: CareCoordinatorReferral, context: AdapterContext): UnifiedReferralModel {
        const { profileStage, user } = context;
        const isActiveCaseload = false; // Care coordinators don't have active caseload state
        const isStatusContainer = false; // Care coordinators don't have status container state
        const shouldShowButtons = false; // Care coordinators don't have buttons

        return {
            id: referral.id,
            type: 'care_coordinator',
            created_at: referral.created_at,
            note: referral.note,
            statusText: this.determineStatusText(referral, profileStage),
            referrer: {
                type: 'user',
                name: this.formatParticipantName(referral.referrer, user.id),
                subtext: referral.referrer.organization_name
            },
            referee: referral.referee ? {
                type: 'user',
                name: this.formatParticipantName(referral.referee, user.id),
                subtext: `Care Coordinator at ${referral.referee.organization_name}`
            } : null,
            shouldShowButtons,
            isStatusContainer,
            isActiveCaseload
        };
    }
} 